<ap-tabset
  type="filled"
  (activeIndexChange)="tabChange($event)"
  [activeIndex]="(indexTab$ | async) ?? 0"
  class="w-90">
  @for (item of userTabs; track $index) {
    <ap-tab [label]="item.label" />
  }
</ap-tabset>

<div class="mt-2">
  <router-outlet />
</div>
